module.exports = __webpack_public_path__ + "img/goal-12.2d07a6cb.png";